import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrl: './steps.component.scss',
})
export class StepsComponent implements AfterViewInit {
  @Input() steps = [];
  @Input() currentStep;
  @Output() currentStepChange = new EventEmitter();
  maxStep;

  ngAfterViewInit(): void {
    this.setCurrentStep(this.steps[0]);
  }

  public setCurrentStep(step) {
    if (this.currentStep && this.currentStep.id == step.id) {
      return;
    }
    if (!this.currentStep || step.id >= this.currentStep.id) {
      this.maxStep = step;
    }
    this.currentStepChange.emit(step);
  }

  public goToStep(step) {
    if (this.maxStep.id >= step.id) {
      this.setCurrentStep(step);
    }
  }
}
